import React from 'react';
import clsx from 'clsx';
import { Link as RouterLink } from 'react-router-dom';
import { asPercent } from '../../../helpers';
import moment from 'moment';

import {
  Card,
  CardActions,
  Divider,
  Button,
  CardHeader,
  Typography,
  CardContent,
  GridLegacy as Grid,
  Switch,
  Checkbox,
  TextField
} from '@mui/material';

import withErrorHandler from '../../../hocs/withErrorHandler'
import axios from '../../../httpClients/axios-datamerch'
import typography from 'theme/typography';
import useClasses from '../../../helpers/useClasses';


const styles = theme => ({
  root: {},
  trial_button: {
    backgroundColor: '#fb8c00',
    color: '#fff',
    textDecoration: 'none',
    '&:hover': {
      backgroundColor: '#fb8c00',
      color: '#fff'
    }
  },
  activate_button: {
    backgroundColor: '#43a047',
    color: '#fff',
    textDecoration: 'none',
    '&:hover': {
      backgroundColor: '#43a047',
      color: '#fff'
    }
  },
  noUnderline: {
    textDecoration: 'none'
  },
  contribution_container: {
    display: 'flex'
  },
  contribution_caution: {
    color: '#fb8c00',
    fontWeight: 'bold'
  },
  contribution_ok: {
    color: '#43a047',
    fontWeight: 'bold'
  },
  contribution_low: {
    color: '#C22121',
    fontWeight: 'bold'
  },
  warning_bar: {
    backgroundColor: '#fb8c00',
    '& p,h3': {
      color: '#fff'
    }
  }
});

const Contribution = props => {
  const { className, is_dm_admin, onAccountContributionOverrideToggle, onAccountContributionRecalculate, account, account_view, ...rest } = props;
  const classes = useClasses(styles);

  const ContributionPercentage = (props) => {
    const { val } = props;
    const percent = asPercent(val);
    let cssName = classes.contribution_caution;
  
    if (percent > 1)
      cssName = classes.contribution_ok;
    if (percent < 0.5)
      cssName = classes.contribution_low;
  
    return (
      <div className={cssName}>
        { percent }% 
      </div>
    );
  }

  const WarningBar = (props) => {
    const { account, ...rest } = props

    if (account.contribution_warning_date){
      return (
        <>
          <Grid
              item
              md={12}
              xs={12}
            >
            <Grid
              container
              spacing={3}
              className={classes.warning_bar}
            >
              <Grid
                item
                md={3}
                xs={6}
              >
                <CardContent>
                  <Grid
                    container
                    justifyContent="space-between"
                  >
                    <Grid item>
                      <Typography
                        className={classes.title}
                        color="textSecondary"
                        gutterBottom
                        variant="body2"
                      >
                        CONTRIBUTION WARNING ISSUED
                      </Typography>
                      <Typography variant="h3">{moment(account.contribution_warning_date).format('MM/DD/YYYY')}</Typography>
                    </Grid>
                  </Grid>
                </CardContent>
              </Grid>
              <Grid
                item
                md={3}
                xs={6}
              >
                <CardContent>
                  <Grid
                    container
                    justifyConteny="space-between"
                  >
                    <Grid item>
                      <Typography
                        className={classes.title}
                        color="textSecondary"
                        gutterBottom
                        variant="body2"
                      >
                        CONTRIBUTION WARNING EXPIRES
                      </Typography>
                      <Typography variant="h3">{moment(account.contribution_warning_expire_date).format('MM/DD/YYYY')}</Typography>
                    </Grid>
                  </Grid>
                </CardContent>
              </Grid>
            </Grid>
            <br/>
          </Grid>
        </>
      )
    }
    
    
    return (
      <>
          <Grid
              item
              md={12}
              xs={12}
            >
            <Divider />
          </Grid>
        </>
    )
  }
  

  let content = null

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <br></br>
      <Grid
          container
          spacing={3}
        >
          <Grid
            item
            md={3}
            xs={6}
          >
            <CardContent>
              <Grid
                container
                justifyContent="space-between"
              >
                <Grid item>
                  <Typography
                    className={classes.title}
                    color="textSecondary"
                    gutterBottom
                    variant="body2"
                  >
                    LAST 90 Days
                  </Typography>
                  <Typography variant="h3"><ContributionPercentage val={Math.min(account.total_ninety_days_contribution_percentage, 1)} /></Typography>
                </Grid>
              </Grid>
            </CardContent>
          </Grid>
          <Grid
            item
            md={3}
            xs={6}
          >
            <CardContent>
              <Grid
                container
                justifyContent="space-between"
              >
                <Grid item>
                  <Typography
                    className={classes.title}
                    color="textSecondary"
                    gutterBottom
                    variant="body2"
                  >
                    LAST 30 Days
                  </Typography>
                  <Typography variant="h3"><ContributionPercentage val={Math.min(account.total_month_contribution_percentage, 1)} /></Typography>
                </Grid>
              </Grid>
            </CardContent>
          </Grid>
          <Grid
            item
            md={3}
            xs={6}
          >
            <CardContent>
              <Grid
                container
                justifyContent="space-between"
              >
                <Grid item>
                  <Typography
                    className={classes.title}
                    color="textSecondary"
                    gutterBottom
                    variant="body2"
                  >
                    LAST 2 WEEKS
                  </Typography>
                  <Typography variant="h3"><ContributionPercentage val={Math.min(account.total_two_week_contribution_percentage, 1)} /></Typography>
                </Grid>
              </Grid>
            </CardContent>
          </Grid>
          <Grid
            item
            md={3}
            xs={6}
          >
            <CardContent>
              <Grid
                container
                justifyContent="space-between"
              >
                <Grid item>
                  <Typography
                    className={classes.title}
                    color="textSecondary"
                    gutterBottom
                    variant="body2"
                  >
                    LAST WEEK
                  </Typography>
                  <Typography variant="h3"><ContributionPercentage val={Math.min(account.total_week_contribution_percentage, 1)} /></Typography>
                </Grid>
              </Grid>
            </CardContent>
          </Grid>
          <WarningBar account={account} />
          <Grid
            item
            md={12}
            xs={12}
          >
            <form
              autoComplete="off"
            >
              <CardActions>
                <Button
                  color="secondary"
                  variant="contained"
                  onClick={onAccountContributionRecalculate}
                >
                  Recalculate Contribution Percentage
                </Button>
              </CardActions>
            </form>
          </Grid>
          { is_dm_admin ?
          <Grid
            item
            md={12}
            xs={12}
          >
            <Divider />
            <br></br>
            <Typography>
            <Switch
                        checked={account.contribution_override}
                        color="primary"
                        onChange={event => onAccountContributionOverrideToggle(event, account)}
                        value="true"
                      />
            
              Contribution Requirement Override
            </Typography>
            <br></br>
          </Grid>
          : null }
        </Grid>
    </Card>
  );
};


export default withErrorHandler(Contribution, axios)